<template>
  <div>
    <div class="print-container ml-1 mb-2">
      <div class="ref-select referenceInfoYear">
        <p class="mr-2 yearText noselect">Ano Base</p>
        <b-form-select v-model="yearSelected" class="select-view noselect">
          <template #first>
            <b-form-select-option :value="null">Selecione o ano</b-form-select-option>
          </template>
          <b-form-select-option v-for="year in years" :key="year.id" :value="year.baseYear">{{ year.baseYear
          }}</b-form-select-option>
        </b-form-select>
      </div>
      <download-excel name="Relatório do Orçamento de Insumos" :fetch="GerarExcel">
        <img class="ml-3 printer-button" src="@/assets/excel.png" :title="$t('gerar-relatorio')" :alt="$t('imprimir')" />
        <span v-if="loadingReport" class="spinner-border spinner-border-sm spinnerConfig" role="status"
          aria-hidden="true"></span>
      </download-excel>
    </div>

    <div id="printMe" class="tableSection">
      <b-row v-if="loaded">
        <b-col class="table-responsive-md table-wrapper-scroll-y my-custom-scrollbar">
          <table class="table table-hover table-sm">
            <thead class="thead-dark">
              <th scope="col">Cod. SAP</th>
              <th scope="col" v-for="item in valuesPlan.header" :key="item.caption">
                {{ item.caption }}
              </th>
            </thead>
            <template v-if="valuesPlan.length == 0">
              Sem dados para visualização<br />
            </template>
            <tbody v-else>
              <tr v-for="item in valuesPlan.table" :key="item.id">
                <td v-if="item.root == true" class="text-truncate tableTxt area" colspan="15"
                  style="max-width: 250px; text-overflow: ellipsis">
                  {{ item.item }}
                </td>
                <template v-else>
                  <td class="text-truncate tableTxt" style="max-width: 250px; text-overflow: ellipsis">
                    {{ item.erpId }}
                  </td>
                  <td v-for="header in valuesPlan.header" :key="header.caption" class="text-truncate tableTxt"
                    style="max-width: 250px; text-overflow: ellipsis"
                    :title="header.field + ': ' + 'R$ ' + item[header.field]">
                    <span v-if="item.item != item[header.field]">
                      <span>
                        {{ fixNumber(item[header.field]) }}
                      </span>
                    </span>
                    <span v-else>
                      {{ arrumarVarName(item.item) }}
                    </span>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row><b-row v-else-if="yearSelected == null" class="waitTxt rowDistance">
        Selecione ano base ...
      </b-row>
      <b-row v-else class="waitTxt rowDistance">
        Aguardando banco de dados ...
      </b-row>
    </div>
  </div>
</template>



<script>
import { urlMainAPI, defaultSuccess } from "@/global";
import axios from "axios";

export default {
  name: "MaterialInputPriceView",
  watch: {
    async yearSelected(value) {
      await this.loadTable(value);
    }
  },
  data() {
    return {
      loadingReport: false,
      valuesPlan: [],
      valuesPlanNewOrder: [],
      loaded: false,
      counter: 0,
      yearSelected: null,
      years: []
    };
  },
  methods: {
    loadTable(value) {
      if (value != null) {
        defaultSuccess(this.$t('carregando-dados'));
        const url = `${urlMainAPI}/calculateinputmaterialpriceplan/${value}/false`;
        axios
          .get(url)
          .then((res) => {
            this.valuesPlan = res.data;
            defaultSuccess(this.$t('dados-carregados'));
          })
          .catch();

        this.loaded = true;
      }
    },

    fixNumber(num) {
      try {
        if (num == null || num == "-9999") {
          return "-";
        }
        return num;
      } catch (error) {
        return "-";
      }
    },

    arrumarVarName(e) {
      let tempName = "";
      let tempNameArr = [];
      const indexOfSlash = e.indexOf("/");
      if (indexOfSlash != -1 && e.indexOf("(") < indexOfSlash) {
        tempNameArr = e.split("/");
        tempName += tempNameArr[0] + ")";

        return tempName;
      } else {
        return e;
      }
    },

    async GerarExcel() {
      this.loadingReport = true;
      const url = `${urlMainAPI}/calculateinputmaterialpriceplan/${this.yearSelected}/true`;
      const response = await this.$http.get(url);
      if (response.data.length == 0) {
        defaultSuccess(this.$t("excel-zerado"));
      } else {
        defaultSuccess(this.$t("excel-orcamento-insumos-exportado-com-sucesso"));
      }
      this.loadingReport = false;
      return response.data.table;
    },

    async loadBaseYears() {
      const url = `${urlMainAPI}/getproductionplanswithrevisionsbyyear`;
      await axios
        .get(url)
        .then((res) => {
          this.years = res.data;
        })
        .catch();
    },
  },

  async created() {
    await this.loadBaseYears();
    this.loadTable(this.yearSelected);
  },
};
</script>

<style scoped>
.print-container {
  display: flex;
  flex-wrap: nowrap;
  width: auto;
}

.printer-button {
  position: absolute;
  height: 30px;
  width: 30px;
  cursor: pointer;
  top: 1rem;
  right: 1rem;
}

.spinnerConfig {
  width: 1.5rem; 
  height: 1.5rem;
  color: #ff5f00;
  position: absolute;
  top: 1.2rem;
  right: 3.5rem;
}

table {
  border-collapse: initial;
  border-spacing: initial;
  font-size: 15px;
}

.my-custom-scrollbar {
  overflow: auto;
  margin: 0px auto;
  padding-left: 0px;
  padding-right: 0px;
}

.my-custom-scrollbar th {
  position: sticky;
  top: 0;
}

.waitTxt {
  justify-content: center;
  background: black;
  color: white;
  margin: 10px auto;
  min-width: 300px;
  max-width: 400px;
}

.rowDistance {
  margin-top: 20px;
}

.tableSection {
  margin: 15px;
}

.area {
  background-color: rgb(59, 58, 58);
  color: white;
  text-align: center;
}

.ref-select {
  display: flex;
}

.ref-select>p,
.ref-select select {
  margin: 0;
  font-size: 0.85rem;
}

.ref-select select {
  height: 25px;
  padding: 1px 5px;
  min-width: 140px;
}

.referenceInfoYear {
  font-size: 0.85rem;
  color: #ff5f00;
  white-space: nowrap;
  text-overflow: ellipsis !important;
  text-align: center;
}

.yearText {
  margin: 0;
  margin-top: 2px !important;
}

.select-view {
  min-width: 100px;
}

@media screen and (max-width: 544px) {
  .printer-button {
    display: none;
  }
}
</style>

